<template>
  <div class="qualificationApplication">
    <personalHead title="新增测试班" :hide="true" />
    <div class="form">
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="200px"
        class="demo-ruleForm abcd-class"
      >
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="报 名 时 间" prop="register_time">
              {{paramsData.registration_start_time}} -- {{paramsData.registration_end_time}}
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="测 试 时 间" prop="test_time">
              {{paramsData.test_start_time}} -- {{paramsData.test_end_time}} 
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="考 点 地 址" prop="test_address">
              {{paramsData.test_detail_addr}}
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="测 试 等 级" prop="test_grade">
              {{paramsData.testGradeArr}}
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="测试班名称" prop="test_class_title">
              {{paramsData.test_class_title}}
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="测试人数上限" prop="testNum">
              {{paramsData.test_num}}
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <div class="Assessor">
              <label>一级考评员</label>
              <div class="con">
                <div class="con_right">
                  {{paramsData.testCoachDetailOne}}
                </div>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <div class="Assessor">
              <label>二级考评员</label>
              <div class="con">
                <div class="con_right">
                  {{paramsData.testCoachDetailSecond}}
                </div>
                
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <div class="Assessor">
              <label>三级考评员</label>
              <div class="con">
                <div class="con_right">
                  {{paramsData.testCoachDetailThree}}
                </div>
                
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <div class="Assessor">
              <label><span style="color: red;">*</span>&nbsp;证书证章邮寄地址</label>
              <div class="con">
                <div class="con_right">
                  {{paramsData.province_name}}{{paramsData.city_name}}{{paramsData.district_name}}
                </div>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="详细地址" prop="addressinfo">
              {{paramsData.mailingtest_detail_addr}}
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="联系人" prop="contact">
              {{paramsData.contact}}
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="联系电话" prop="contact_number">
              {{paramsData.contact_number}}
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item class="submit">
             
              <el-button type="danger" @click="goReturn" style="width:100px;height:40px" plain>返回</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <el-dialog :title="title" :visible.sync="dialogVisible" :width="dialogWidth" class="visible">
      <el-row :gutter="10" style="border-bottom:1px solid #eee;">
        <el-col :xs="24" :sm="24" :md="18" style="border-right:1px solid #eee;">
          <el-row :gutter="11" style="margin-bottom:10px;" v-if="title=='考评组长' ? false : true ">
            <el-col :xs="8" :sm="6" :md="8">
              <el-select
                v-model="searForm.province"
                placeholder="请选择省"
                @change="chooseProvince($event)"
                size="medium"
                style="width:100%"
              >
                <el-option
                  v-for="item in province"
                  :key="item.id"
                  :label="item.area_name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :xs="8" :sm="6" :md="8">
              <el-select
                v-model="searForm.city"
                placeholder="请选择城市"
                @change="chooseCity($event)"
                size="medium"
                style="width:100%"
              >
                <el-option
                  v-for="item in city"
                  :key="item.id"
                  :label="item.area_name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-col>   
            <el-col :xs="8" :sm="6" :md="8">
              <el-select
                v-model="searForm.district"
                placeholder="请选择地区"
                @change="chooseDistrict($event)"
                size="medium"
                style="width:100%"
              >
                <el-option
                  v-for="item in district"
                  :key="item.id"
                  :label="item.area_name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="12" style="margin-bottom:10px;" v-if="title== '考评组长' ? false : true">
            <el-col :xs="8" :sm="8" :md="8">
              <el-input
                v-model="searForm.keyword"
                placeholder="姓名查询"
                size="medium"
                style="width:100%"
              ></el-input>
            </el-col>
            <el-col :xs="16" :sm="16" :md="16">
              <el-button type="primary" icon="el-icon-search" size="medium" @click="searchPerson" style="padding:10px 5px;">搜索</el-button>
              <el-button icon="el-icon-delete" size="medium" @click="clear" style="padding:10px 5px;">清空</el-button>
            </el-col>
          </el-row>
          <el-table :data="tableData" style="width: 100%;min-height:300px" @row-click="addPerson">
            <el-table-column prop="name" label="姓名" align="center"></el-table-column>
            <el-table-column prop="evaluator_rank_name" label="级别" align="center"></el-table-column>
            <el-table-column prop="mobile" label="手机号" align="center"></el-table-column>
          </el-table>
          <el-row :gutter="12" v-if="title== '考评组长' ? false : true">
            <el-col :xs="24" :sm="24" :md="24">
              <div class="pagination" style="margin-top: 10px;text-align: center;">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :current-page="currentPage"
                  @current-change="handleCurrentChange"
                  :page-size="paging.limit"
                  :total="totalCount"
                  v-if="totalCount>5"
                ></el-pagination>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :xs="24" :sm="24" :md="6">
          <div style="padding-left:10px;">
            <h3>已选{{title}}</h3>
          </div>
          <ul class="visible_ul" v-if="title=='一级考评员'">
            <li
              v-for="(item,index) in choseFirstAppraiser"
              :key="index"
              class="choseLi"
              @mouseover="showIcon = item"
              @mouseleave="showIcon = ''"
            >
              <span class="name">{{item.name}}</span>
              <i
                :class="item == showIcon?'delet-icon el-icon-close':''"
                @click="remover(item,index)"
              ></i>
            </li>
          </ul>
          <ul class="visible_ul" v-if="title=='二级考评员'">
            <li
              v-for="(item,index) in choseSecondAppraiser"
              :key="index"
              class="choseLi"
              @mouseover="showIcon = item"
              @mouseleave="showIcon = ''"
            >
              <span class="name">{{item.name}}</span>
              <i
                :class="item == showIcon?'delet-icon el-icon-close':''"
                @click="remover(item,index)"
              ></i>
            </li>
          </ul>
          <ul class="visible_ul" v-if="title=='三级考评员'">
            <li
              v-for="(item,index) in choseThirdAppraiser"
              :key="index"
              class="choseLi"
              @mouseover="showIcon = item"
              @mouseleave="showIcon = ''"
            >
              <span class="name">{{item.name}}</span>
              <i
                :class="item == showIcon?'delet-icon el-icon-close':''"
                @click="remover(item,index)"
              ></i>
            </li>
          </ul>
          <ul class="visible_ul" v-if="title=='考评组长'">
            <li
              v-for="(item,index) in choseleaderList"
              :key="index"
              class="choseLi"
              @mouseover="showIcon = item"
              @mouseleave="showIcon = ''"
            >
              <span class="name">{{item.name}}</span>
              <i
                :class="item == showIcon?'delet-icon el-icon-close':''"
                @click="remover(item,index)"
              ></i>
            </li>
          </ul>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="chooseCancle">取 消</el-button>
        <el-button type="primary" @click="chooseComplete">完 成</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { GetUserCoachList, GetDistrictList } from "@/api/admin/common.js";
//import { GetSites, GetGrades, CreateTestApply } from "@/api/admin/test.js";
import { GetSites, GetGrades ,CreateTestApply } from "@/api/admin/test.js";
import personalHead from "@/views/admin/components/personalHead.vue";
import { isMobile, isNumber } from "@/util/validate.js";
import { GetTestApplyList,GetExaminerClassList } from "@/api/admin/test.js";
var checkPhone = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入联系方式"));
  } else {
    if (isMobile(value)) {
      callback();
    } else {
      return callback(new Error("请输入正确的电话"));
    }
  }
};
var checkPeople = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入测试人数，为阿拉伯数字"));
  } else {
    if (isNumber(value)) {
      callback();
    } else {
      return callback(new Error("请输入阿拉伯数字"));
    }
  }
};
export default {
  components: {
    personalHead
  },
  data() {
    return {
      testID:0,
      ruleForm: {
        grade_one_examiner: [],
        grade_two_examiner: [],
        grade_three_examiner: [],
        // evaluation_team_leader: "",
        test_grade: []
      },
      firstAssessorData: [],
      secondAssessorData: [],
      thirdAssessorData: [],

      firstAssessorList: [],
      secondAssessorList: [],
      thirdAssessorList: [],

      // leaderList: [],
      // leaderListEcho: [],

      rules: {
        province:[
          {
            required: true,
            message: " ",
            trigger: "blur"
          }
        ],
        city:[
          {
            required: true,
            message: "  ",
            trigger: "blur"
          }
        ],   
        district:[
          {
            required: true,
            message: "  ",
            trigger: "blur"
          }
        ],
        register_time: [
          {
            required: true,
            message: "请选择报名时间",
            trigger: "change"
          }
        ],
        test_time: [
          {
            required: true,
            message: "请选择测试时间",
            trigger: "change"
          }
        ],
        test_address: [
          {
            required: true,
            message: "请选择考点地址",
            trigger: "change"
          }
        ],
        test_grade: [
          {
            required: true,
            message: "请选择测试等级",
            trigger: "change"
          }
        ],
        test_class_title: [
          {
            required: true,
            message: "请填写测试班名称",
            trigger: "blur"
          }
        ],
        // testNum: [
        //   {
        //     required: true,
        //     message: "请填写测试班人数",
        //     trigger: "blur"
        //   }
        // ],
        contact: [
          {
            required: true,
            message: "请填写联系人",
            trigger: "blur"
          }
        ],
        
        addressinfo:[
          {
            required: true,
            message: "请填写详细地址",
            trigger: "blur"
          }
        ],
        testNum: [{ required: true, validator: checkPeople, trigger: "blur" }],
        contact_number: [
          { required: true, validator: checkPhone, trigger: "blur" }
        ]
      },
      test_addressList: [],
      test_gradeList: [],
      dialogVisible: false,
      title: "",
      tableData: [],
      province: [],
      city: [],
      district: [],
      searForm: {},

      choseFirstAppraiser: [],
      choseSecondAppraiser: [],
      choseThirdAppraiser: [],
      choseleaderList: [],
      showIcon: "",
      paging: {
        limit: 5,
        page: 1
      },
      evaluator_rank: {},
      totalCount: 0,
      loading: false,
      currentPage: 1,
      dialogWidth: "60%",
      screenWidth: document.body.clientWidth,
      paramsData:{}
    };
  },
  watch: {
    "searForm.province"(val) {
      
      GetDistrictList({ parent_id: val }).then(data => {
        this.city = data.data.result.items;
        this.searForm.city = this.city[0].id;
        this.chooseCity(this.searForm.city);
      });
    },
    screenWidth(val) {
      this.screenWidth = val;
      if (this.screenWidth < 769) {
        this.dialogWidth = "90%";
      } else {
        this.dialogWidth = "60%";
      }
    }
  },
  created() {
    
    this.testID = this.$route.query.id;//this.$router.query.id;
    this.getList();
    if (this.screenWidth < 768) {
      this.dialogWidth = "90%";
    }
  },
  mounted() {
    const that = this;
    this.$nextTick(() => {
      window.onresize = () => {
        return (() => {
          window.screenWidth = document.body.clientWidth;
          that.screenWidth = window.screenWidth;
        })();
      };
    });
  },
  methods: {
    //{"testId":this.testID}
    getList() {
       var params = {
         "testId":this.testID,
         "limit":8,
         "page":1
         };
        GetTestApplyList(Object.assign(params)).then(data => {
          var list = data.data.result;
          if (list) {
            this.tableData = list.items;
            if(this.tableData.length>0){
              this.paramsData = this.tableData[0];
              this.paramsData.testGradeArr = "";   //test_grade
              this.paramsData.testCoachDetailOne = "";
              this.paramsData.testCoachDetailSecond = "";
              this.paramsData.testCoachDetailThree = "";
              for(var i=0;i<this.paramsData.test_grade.length;i++){
                if(this.paramsData.testGradeArr != ""){
                  this.paramsData.testGradeArr = this.paramsData.testGradeArr +"," + this.paramsData.test_grade[i].grade;
                }else{
                  this.paramsData.testGradeArr = this.paramsData.test_grade[i].grade;
                }
              }
              for(var j = 0; j < this.paramsData.testcoachdetail.length; j++){
                  if(this.paramsData.testcoachdetail[j].testcoachlevel == 1 || this.paramsData.testcoachdetail[j].testcoachlevel == '1'){ 
                    this.paramsData.testCoachDetailOne = this.paramsData.testCoachDetailOne +"," + this.paramsData.testcoachdetail[j].testcoachName;
                  }else if(this.paramsData.testcoachdetail[j].testcoachlevel == 2 || this.paramsData.testcoachdetail[j].testcoachlevel == '2'){
                    this.paramsData.testCoachDetailSecond = this.paramsData.testCoachDetailSecond +"," + this.paramsData.testcoachdetail[j].testcoachName;
                  }else if(this.paramsData.testcoachdetail[j].testcoachlevel == 3 || this.paramsData.testcoachdetail[j].testcoachlevel == '3'){
                    this.paramsData.testCoachDetailThree = this.paramsData.testCoachDetailThree +"," + this.paramsData.testcoachdetail[j].testcoachName;
                  }
              }
              
              this.paramsData.testCoachDetailOne  = this.paramsData.testCoachDetailOne.substring(1);
              this.paramsData.testCoachDetailSecond  = this.paramsData.testCoachDetailSecond.substring(1); 
              this.paramsData.testCoachDetailThree  = this.paramsData.testCoachDetailThree.substring(1); 
              this.paramsData.registration_start_time = this.paramsData.registration_start_time.substring(0,10); 
              //{{paramsData.test_start_time}} -- {{paramsData.test_end_time}} registration_end_time
              this.paramsData.test_start_time = this.paramsData.test_start_time.substring(0,10); 
              this.paramsData.test_end_time = this.paramsData.test_end_time.substring(0,10); 
              this.paramsData.registration_end_time = this.paramsData.registration_end_time.substring(0,10); 
              
            }
            
            this.totalCount = list.totalCount;
            //this.doList();
          }
        });
      
    },
    sub(ruleForm) {},
    //  成人考评员验证
    adultCompare(levelMin) {},
    //  成人总数比较
    allAdultCompare(num) {},
    //  儿童考评员验证
    childrenCompare(levelMin) {},
    //  儿童总数比较
    allchildrenCompare(num) {},
    //组长验证
    leaderCompare() {},
    addAssessor(i) {},
    // 考评员表格数据
    firstData(i) {},
    getDistrictList() {},
    chooseProvince(item) {},
    chooseCity(item) {},
    chooseDistrict() {},
    //  搜索
    searchPerson() {},
    clear() {},
    addPerson(row) {},
    //考评员列表分页
    handleCurrentChange(cpage) {},
    chooseComplete() {},
    // 考评组长数据
    // getLeaderList() {
    //   this.tableData = this.leaderList;
    // },
    chooseCancle() {},
    remover(item, index) {},
    
    goReturn() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="less">
.qualificationApplication {
  .form {
    width: 70%;
    .Assessor {
      overflow: hidden;
      padding-bottom: 20px;
      label {
        float: left;
        display: block;
        width: 200px;
        text-align: right;
        color: #606266;
        line-height: 40px;
        padding-right: 42px;
        font-size: 14px;
        font-weight: 400;
        box-sizing: border-box;
      }
      @media screen and (max-width: 767px) {
        label {
          width: 121px;
          float: none;
        }
      }
      .con {
        line-height: 40px;
        position: relative;
        font-size: 14px;
        margin-left: 200px;
        .con_right {
          p {
            width: 100%;
            height: 40px;
            background-color: #f5f7fa;
            color: #c0c4cc;
            line-height: 40px;
            padding: 6px 15px;
            border-radius: 4px;
            border: 1px solid #dcdfe6;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            overflow: hidden;
            margin-bottom: 5px;
            span {
              font-size: 12px;
              border: 1px solid #e9e9eb;
              border-radius: 4px;
              background-color: #f4f4f5;
              color: #909399;
              height: 24px;
              padding: 0 8px;
              line-height: 22px;
              display: block;
              float: left;
              margin-right: 5px;
            }
          }
          .add {
            color: #f56c6c;
            cursor: pointer;
            // font-size:14px !important;
          }
        }
      }
      @media screen and (max-width: 767px) {
        .con {
          margin-left: 0;
        }
      }
    }
    .el-form-item__label {
      padding-right: 42px;
      font-size: 14px;
      font-weight: 400;
    }
    .submit {
      text-align: center;
      .el-form-item__content {
        margin-left: 0px !important;
      }
    }
  }
  .visible {
    .visible_ul {
      height: 400px;
      overflow-x: hidden;
      overflow-y: scroll;
      .choseLi {
        position: relative;
        margin: 10px 0px;
        padding: 0px 10px;
        font-size: 16px;
        display: flex;
        .name {
          display: inline-block;
          padding: 7px;
        }
        .delet-icon {
          border-radius: 50%;
          background: #aaa;
          color: #fff;
          position: absolute;
          right: 10px;
          top: 50%;
          margin-top: -7px;
        }
      }
      .choseLi:hover {
        background: #eee;
        border-radius: 10px;
      }
    }
    @media screen and(max-width:767px){
      .visible_ul{
        height: 100px !important;
      }
    }
    .visible_ul::-webkit-scrollbar {
      display: none;
    }
    .pagination {
      text-align: center;
      margin: 30px 0px 10px 0px;
    }
  }
}
.abcd-class{
  width: 900px;
}
</style>


